/* page-zirconium-fountain-pen.js — from zirconium-fountain-pen.html (2026-08-27) */
(function(){
  // Gallery swap (placeholders until final photography is hosted)
  var main=document.getElementById('gallery-main');
  var thumbs=document.querySelectorAll('.gallery-thumb');
  function pick(t){
    thumbs.forEach(function(x){x.classList.remove('is-active');});
    t.classList.add('is-active');
    main.src=t.getAttribute('data-full');
    main.alt=t.getAttribute('data-alt');
  }
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){pick(t);});
    t.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();pick(t);}});
  });

  // Launch gate: pen goes live Friday Aug 28 2026, 12:00 PM Central (17:00 UTC).
  // Fail-open: with JS disabled the CTA shows; the product is unpublished until noon anyway.
  var LAUNCH=Date.UTC(2026,7,28,17,0,0);
  var block=document.getElementById('countdown-block');
  var timer=document.getElementById('countdown-timer');
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var d=LAUNCH-Date.now();
    if(d<=0){
      block.classList.remove('is-on');
      document.body.classList.remove('pre-launch');
      clearInterval(iv);
      return;
    }
    document.body.classList.add('pre-launch');
    block.classList.add('is-on');
    var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
    timer.textContent=pad(h)+':'+pad(m)+':'+pad(s);
  }
  var iv=setInterval(tick,1000);
  tick();

  // Tray sold-out state (Liquid binds .tray-count server-side; 0 flips the copy)
  var counts=document.querySelectorAll('.tray-count');
  if(counts.length&&counts[0].textContent.trim()==='0'){
    var callout=document.getElementById('tray-callout');
    if(callout){callout.innerHTML=callout.getAttribute('data-soldout')||'All trays are claimed. The pen is still available.';}
  }
})();
